export default __webpack_public_path__ + "static/media/downArrow.b1dcea65.svg";